import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "../node_modules/video-react/dist/video-react.css";
import "../node_modules/jodit-pro-react/build/esm/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

const firebaseServiceWorkerParams = new URLSearchParams({
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID || "",
  appId: process.env.REACT_APP_FIREBASE_APPID || "",
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(`/firebase-messaging-sw.js?${firebaseServiceWorkerParams.toString()}`)
    .then((registration) => {
      console.log("SW registered:", registration);
    })
    .catch((err) => console.log("SW error:", err));
}

reportWebVitals();
